module.exports = __webpack_public_path__ + "static/img/community22.c4670d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community22.png
// module id = v96/
// module chunks = 0